import { render, staticRenderFns } from "./landing-banners.vue?vue&type=template&id=1b0161f9&"
import script from "./landing-banners.vue?vue&type=script&lang=js&"
export * from "./landing-banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports